import React from "react";
import { Text, TextProps } from "@commonsku/design-system";
import { sanitizeNoteHtml } from "../../../utils/sanitizeHtml";

// `TextProps.children` is required, but a `dangerouslySetInnerHTML` element
// must not also be given children (nested or as a prop) — the two together
// trip a lint rule and, worse, would let React's own children silently race
// the raw HTML. Cast away the erroneous `children` requirement for this one
// use rather than passing a `{null}` child to satisfy the type.
const HtmlText = Text as React.ComponentType<Omit<TextProps, "children">>;

export interface TaskMessageTextProps {
  html: string;
}

/** A task's message body, sanitized before being rendered as HTML. */
const TaskMessageText = ({ html }: TaskMessageTextProps) => (
  <HtmlText
    fontSize="sm"
    color="fg"
    margin="0"
    lineClamp={2}
    dangerouslySetInnerHTML={{ __html: sanitizeNoteHtml(html ?? "") }}
  />
);

export default TaskMessageText;
